export default __webpack_public_path__ + "static/media/picture-01.a8eb3c3b.svg";